const BASE_GLOBAL_RULES = {
  published: {
    readOnly: true,
    reason: "Waiver is published.",
  },
  archived_by_admin: {
    readOnly: true,
    reason: "Archived waivers cannot be edited.",
  },  
  archived_by_new_version: {
    readOnly: true,
    reason: "This waiver was Archived. Cannot edit it.",
  },
  archived_by_location_deletion: {
    readOnly: true,
    reason: "This waiver was Archived due to Location Deletion. Cannot edit it.",
  },
};

const RAW_STEP_RULES = {
  step2: {
    new_version: {
      readOnly: true,
      reason:
        "Locations cannot be changed in a new version of a waiver.",
    },
    published: {
      readOnly: true,
      reason: "Locations cannot be changed once a waiver is published.",
    },
  },

  step3: {
    // nothing needed here. Only BASE_GLOBAL RULES
  },

  step4: {
    // nothing needed here. Only BASE_GLOBAL RULES
  },

  step5: {
    // nothing needed here. Only BASE_GLOBAL RULES
  },

  step6: {
    // nothing needed here. Only BASE_GLOBAL RULES
  },

  step7: {
    // nothing needed here. Only BASE_GLOBAL RULES
  },

};

// 🔥 Magic happens here
const WAIVER_STEP_RULES = Object.fromEntries(
  Object.entries(RAW_STEP_RULES).map(([step, rules]) => [
    step,
    { ...BASE_GLOBAL_RULES, ...rules },
  ])
);

export default WAIVER_STEP_RULES;